var eventDates = {
  timezone:"Pacific/Honolulu",
  load:function(){
    var elements = document.querySelectorAll("[data-eventDate]");
    elements.forEach(e=>{

      e.innerHTML = moment(parseInt(e.getAttribute("data-eventDate"))).fromNow();
    });
  },
  display:function(holderID,dates){
    this.dates = dates;
    this.holderID = holderID;
    this.holder = document.getElementById(holderID);

    var dateHTML = "";
    this.dates.forEach(d=>{
      dateHTML += this.html(d);
    });
    this.holder.innerHTML = dateHTML;
  },
  html:function(date){
    var weekdays = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

    var returnVal = "<div>";

    if(date.repeat_day){
      returnVal += "Every "+weekdays[date.repeat_day];
    }
    else if(date.repeat_date){
      returnVal += "Every "+this.humanize(date.repeat_date)+" of the Month";
    }
    else if(date.repeat_day_week){
      var [dayNum,weekNum] = date.repeat_day_week.split(":");
      returnVal += "Every "+this.humanize(weekNum)+" "+weekdays[dayNum]+" of the Month";
    }
    else{
      returnVal += this.dateFormat(date.date);
    }

    returnVal += " "+this.timeFormat(date.startTime)+" - "+this.timeFormat(date.endTime)+" ("+moment.tz(this.timezone).zoneAbbr()+")</div>";
    return returnVal;
  },
  dateFormat:function(dateValue){
    var [valueMonth,valueDate,valueYear] = dateValue.split("-");
    var dateObj = new Date(Date.UTC(valueYear,parseInt(valueMonth)-1,valueDate));
    var timestamp = dateObj.getTime();
    return moment.utc(timestamp).format("LL");
  },
  timeFormat:function(timestamp){

    return moment.utc(parseInt(timestamp)).format("hh:mm a");
  },
  humanize:function(number) {
    if(number % 100 >= 11 && number % 100 <= 13)
        return number + "th";

    switch(number % 10) {
        case 1: return number + "st";
        case 2: return number + "nd";
        case 3: return number + "rd";
    }

    return number + "th";
  }
}

window.addEventListener("DOMContentLoaded",()=>{
  eventDates.load();
});
